import React from "react";
import { Route, Routes } from "react-router-dom";
import SeeCatalog from "./SeeCatalog";
import SeeCatalogDetails from "./SeeCatalogDetails";
import { ToastContainer } from "react-toastify";
import NotFound from "../App/Components/NotFound";
import RoomView from "./3DRoomView";

const ShowCaseRoute = () => {
    return (
        <div>
            <ToastContainer />
            <Routes>
                <Route path="/catalog-screen/see-catalog" element={<SeeCatalog />} />
                <Route path="/catalog-screen/see-catalog/:id/see-catalog-details" element={<SeeCatalogDetails />} />
                <Route path="/catalog-screen/see-catalog/:id/see-catalog-details/room-view" element={<RoomView />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </div>
    );
};

export default ShowCaseRoute;
